angular.module('sharedInitiatives', [])

.service('initiativesReportService', function($http, URLS) {
	var urlPfx = '2/Dimensions/factndx/';
	return {
		getInitiativesData: getInitiativesData,
		getStagesData: getStagesData
	};

	function getInitiativesData(metricNdx, vStreams, factory, supplierNdxs) {
		if (!factory) {
			factory = globalConfig.factory.id;
		}
		var url = String.format(URLS.host + URLS.projectInitiatives, factory);
		if (metricNdx) {
			url += '?metricId=' + metricNdx;
		}
		if (vStreams && vStreams.length > 0) {
			url += '&vstreams=' + vStreams.toString();
		}
		if (supplierNdxs) {
			url = addQueryParam(url, null, {'suppliers': supplierNdxs}, false);
		}

		return $http.get(url)
			.then(getInitiativesComplete)
			.catch(getInitiativesFailed);

		function getInitiativesComplete(response) {
			return response.data;
		}

		function getInitiativesFailed(error) {
			return undefined;
		}
	}
	
	function getStagesData(factory) {
		if (!factory) {
			factory = globalConfig.factory.id;
		}
		var url = String.format(URLS.host + URLS.projectStagesBySite, factory);
		
		return $http.get(url)
			.then(getStagesDataComplete)
			.catch(getStagesDataFailed);

		function getStagesDataComplete(response) {
			return response.data;
		}

		function getStagesDataFailed(error) {
			return undefined;
		}
	}
})

.controller('initiativesCtrl', function($rootScope, $scope, $filter, $uibModal, initiativesReportService, a3ModalService) {
	$scope.initiatives = [];
	$scope.stages = [];
	$scope.viewA3Report = function(ndx, factoryNdx) {
		
		var modalInstance = a3ModalService.openModal(ndx, factoryNdx);
		
		modalInstance.result.finally(function() {
			a3ModalService.removeNoPrintClass();
		});
	};

	var tooltipMap = {'30-bad':'Not on plan, and there are issues',
					  '10-good':'On plan',
					  '20-warn':'Not on plan, but we can recover'};

	var colorMap = {'30-bad': 'redState',
																	'20-warn': 'yellowState',
																	'10-good': 'greenState'};

	var colorClassMap = {
		'30-bad': 'bad',
		'20-warn': 'warn',
		'10-good': 'good',
		'complete': 'complete'
	};

	$scope.getStageWidth = function(row) {
		if (row.sequence != -1 && row.sequence != 1000 && !row.validateInitiativeFlag) {
			return (($scope.stages[row.leanDirFactoryNdx].length - 2) * 20) + 20;
		}
		return 'auto';
	};
	$scope.getA3Class = function(row) {
		var state = row.validateInitiativeFlag && row.sequence != 1000 ? 'complete' : row.stateColor;
		return colorClassMap[state];
	};

	$scope.getStageTitle = function(stateColor) {
		return tooltipMap[stateColor];
	};
	$scope.getStageColor = function(initiativeSequence, stageSequence, stateColor) {
		var classColor = 'blankState';
		if (stageSequence < initiativeSequence) {
			classColor = 'completeState';
		} 
		else if (stageSequence == initiativeSequence) {
			classColor = colorMap[stateColor];
		} 
		return classColor;
	};

	$scope.chooseSite = chooseSite;

	function mapColors() {
		//ALSO strips initiative name
		angular.forEach($scope.initiatives, function(init) {
			init.name = strip(init.name);
			var s = init.state;
			init.defineClass = 'blankState';
			init.measureClass = 'blankState';
			init.analyzeClass = 'blankState';
			init.implementClass = 'blankState';
			init.controlClass = 'blankState';
			init.defineTip = 'Define (Plan)';
			init.measureTip = 'Measure (Plan)';
			init.analyzeTip = 'Analyze (Plan)';
			init.implementTip = 'Improve (Do)';
			init.controlTip = 'Control (Check)';
			init.colorClass = colorMap[init.stateColor];
			if (s === 'Standardize (Act)') {
				init.defineClass = 'completeState';
				init.measureClass = 'completeState';
				init.analyzeClass = 'completeState';
				init.implementClass = 'completeState';
				init.controlClass = 'completeState';
				init.defineTip += ':Complete';
				init.measureTip += ':Complete';
				init.analyzeTip += ':Complete';
				init.implementTip += ':Complete';
				init.controlTip += ':Complete';
			} else if (s === 'Define (Plan)') {
				init.defineClass = colorMap[init.stateColor];
				init.defineTip += ':' + tooltipMap[init.stateColor];
			} else if (s === 'Measure (Plan)') {
				init.defineClass = 'completeState';
				init.defineTip += ':Complete';
				init.measureClass = colorMap[init.stateColor];
				init.measureTip += ':' + tooltipMap[init.stateColor];
			} else if (s === 'Analyze (Plan)') {
				init.defineClass = 'completeState';
				init.measureClass = 'completeState';
				init.defineTip += ':Complete';
				init.measureTip += ':Complete';
				init.analyzeClass = colorMap[init.stateColor];
				init.analyzeTip += ':' + tooltipMap[init.stateColor];
			} else if (s === 'Implement (Do)') {
				init.defineClass = 'completeState';
				init.measureClass = 'completeState';
				init.analyzeClass = 'completeState';
				init.defineTip += ':Complete';
				init.measureTip += ':Complete';
				init.analyzeTip += ':Complete';
				init.implementClass = colorMap[init.stateColor];
				init.implementTip += ':' + tooltipMap[init.stateColor];
			} else if (s === 'Control (Check)') {
				init.defineClass = 'completeState';
				init.measureClass = 'completeState';
				init.analyzeClass = 'completeState';
				init.implementClass = 'completeState';
				init.defineTip += ':Complete';
				init.measureTip += ':Complete';
				init.analyzeTip += ':Complete';
				init.implementTip += ':Complete';
				init.controlClass = colorMap[init.stateColor];
				init.controlTip += ':' + tooltipMap[init.stateColor];
			}
		});
	}

	function getTableData() {
		return initiativesReportService.getInitiativesData(incomingData.metricNdx, incomingData.initVsList,
			incomingData.factory, incomingData.supplierNdxs)
			.then(function(data) {
				$scope.initiatives = data;
				if ($scope.initiatives && $scope.initiatives.length > 0) {
					$scope.empty = false;
					mapColors();
				}
				else {
					$scope.empty = true;
					$scope.projectsBy = incomingData.supplierNdxs ? 'Supplier': 'Metric';
				}
			});
	}

	function getStages() {
		return initiativesReportService.getStagesData(incomingData.factory)
		.then(function(data) {
			$scope.stages = data;
			getTableData();
		});
	}

	function chooseSite(index) {
		openNewProject($scope.sites[index]);
	}

	function openNewProject(site) {
		var newProjectScope = $scope.$new();
		newProjectScope.isSupplierProject = site.supplierNdx !== undefined;
		newProjectScope.supplierNdx = site.supplierNdx;
		newProjectScope.metricNdx = incomingData.metricNdx;
		newProjectScope.valueStreamNdxs = incomingData.initVsList;
		newProjectScope.factoryNdx = site.id;
		
		var opts = {
			scope: newProjectScope,
			templateUrl: '/application/f/lean-projects/new-project/new-project.html',
			size: 'lg',
			backdrop: 'static'
		};

		var instance = $uibModal.open(opts);
		newProjectScope.closeDialog = function () {
			instance.close();
			newProjectScope.$destroy();
		};

		newProjectScope.result = function (message, isSuccessful, stageId) {
			instance.close();
			newProjectScope.$destroy();
			var time = 3000;
			$rootScope.$emit('toast', {
				'message': message,
				'success': isSuccessful,
				'time': time
			});
			if (isSuccessful) getStages();
		};

		newProjectScope.addToastMessage = function (message, type) {
			$rootScope.$emit('toast', {
				'message': message,
				'success': type
			});
		};
	}

	function getSiteDetails(siteId, factoryNdxToSupplierMap, extraText) {
		return {
			'id': siteId,
			'name': globalConfig.user.authFacts[siteId]['alias'] + extraText,
			'supplierNdx': factoryNdxToSupplierMap[siteId]
		};
	}

	function init() {
		var sites = incomingData.factory ? incomingData.factory.toString().split(',') : [globalConfig.factory.id.toString()];
		var factoryNdxToSupplierMap = {};
		var isSupplierPortal = globalConfig.user.role === 'Supplier';
		if (incomingData.supplierNdxs !== undefined) {
			var supplierNdxs = incomingData.supplierNdxs.toString().split(',');
			angular.forEach(supplierNdxs, function(value, index) {
				factoryNdxToSupplierMap[sites[index]] = value;
			});
		}
		if (sites.length > 1) {
			var currentSiteIndex = _.indexOf(sites, globalConfig.factory.id.toString());
			if (currentSiteIndex >= 0) {
				sites.splice(currentSiteIndex, 1);
			}

			sites = _.sortBy(_.map(sites, function (siteId) {
				return getSiteDetails(siteId, factoryNdxToSupplierMap, '');
			}), ['name']);

			if (currentSiteIndex >= 0) {
				sites = [getSiteDetails(globalConfig.factory.id, factoryNdxToSupplierMap, ' (current site)')].concat(sites);
			}
		} else {
			sites = [getSiteDetails(sites[0], factoryNdxToSupplierMap, ' (current site)')];
		}
		$scope.sites = sites;
		if ((incomingData.factory && incomingData.factory.toString().split(',').length == 1) ||
			incomingData.supplierNdxs !== undefined) {
			$scope.showCreateProject = true;
		}
		$scope.isScoreCard = typeof incomingData.isScoreCard !== 'undefined' && incomingData.isScoreCard;
		if (isSupplierPortal) {
			$scope.showCreateProject = false;
		}
		getStages();
	}

	init();
});
